module.exports = __webpack_public_path__ + "img/serviceImg3.d690e1db.gif";